<section class="py-5" style="background: linear-gradient(135deg, #f8fafc 60%, #e0e7ff 100%); min-height: 100vh;">
    <div class="container">
        <div class="row justify-content-center align-items-center" style="min-height: 60vh;">
            <div class="col-md-9 col-lg-7">
                <div class="card shadow-lg border-0 rounded-4 p-5" style="background: rgba(255,255,255,0.95);">
                    <div class="text-center mb-4">
                        <div class="mx-auto mb-3 d-flex align-items-center justify-content-center" style="width: 72px; height: 72px; background: linear-gradient(135deg, #22d3ee 70%, #4f46e5 100%); border-radius: 50%;">
                            <i class="fa fa-check fa-2x text-white"></i>
                        </div>
                        <h2 class="fw-bold mb-2" style="letter-spacing: -.5px;">Vielen Dank für Ihre Bestellung!</h2>
                        <p class="lead text-secondary mb-1">
                            Wir haben Ihre Bestellung erhalten und bereiten nun alles für Sie vor.
                        </p>
                        <p class="text-muted">
                            Die Bestelldetails wurden an <strong class="text-primary">{{ email }}</strong> gesendet.
                        </p>
                    </div>

                    <div class="text-center mb-4">
                        <h5 class="fw-semibold mb-2 text-dark">Wie geht es weiter?</h5>
                        <p class="mb-2">
                            Um jetzt und zukünftig sicher auf Ihre gekauften Daten zuzugreifen, erstellen Sie bitte ein kostenloses Konto. So haben Sie Zugriff auf Ihre Bestellhistorie, Download-Links und exklusive Updates.
                        </p>
                        <p class="mb-0 text-muted small">
                            Sie haben bereits ein Konto? Dann loggen Sie sich einfach ein, um Ihre Daten einzusehen.
                        </p>
                    </div>

                    <div class="d-grid gap-2">
                        <button class="btn btn-gradient-primary btn-lg rounded-pill fw-semibold" (click)="onCreateAccount()">
                            <i class="fa fa-user-plus me-2"></i> Jetzt Account anlegen
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
